import { render, staticRenderFns } from "./HomePreview.vue?vue&type=template&id=64f871c0&scoped=true"
import script from "./HomePreview.vue?vue&type=script&lang=js"
export * from "./HomePreview.vue?vue&type=script&lang=js"
import style0 from "./HomePreview.vue?vue&type=style&index=0&id=64f871c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f871c0",
  null
  
)

export default component.exports